import React, { useEffect, useState } from 'react';
import './Testimonial.css';
import { getTestimonials } from '../services/communityService';

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [current, setCurrent] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    getTestimonials().then(setTestimonials);
  }, []);

  const nextSlide = () => {
    setCurrent((current + 1) % testimonials.length);
    setExpanded(false); // collapse on slide change
  };
  
  const prevSlide = () => {
    setCurrent((current - 1 + testimonials.length) % testimonials.length);
    setExpanded(false); // collapse on slide change
  };

  const truncateWords = (text, wordLimit) => {
    const words = text.trim().split(/\s+/);
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(' ') + '...'
      : text;
  };

  return (
    <section className="testimonial-section fade-in">
      <h2 className="slide-left">MESSAGES THAT BRIGHTEN OUR DAY</h2>
      <div className="testimonial-wrapper">
        <button onClick={prevSlide} className="nav-btn">&#8592;</button>

        {testimonials.length > 0 && (
          <div className="testimonial-card slide-right">
            <img src={testimonials[current].image} alt={testimonials[current].name} />
            <div className="testimonial-text">
              <h3>{testimonials[current].name}</h3>
              <h4>{testimonials[current].service}</h4>
              <p>
                {expanded
                  ? testimonials[current].feedback
                  : truncateWords(testimonials[current].feedback, 50)
                }
                {testimonials[current].feedback.trim().split(/\s+/).length > 50 && (
                  <span
                    className="read-more"
                    onClick={() => setExpanded(!expanded)}
                  >
                    {expanded ? ' Show less' : ' Read more'}
                  </span>
                )}
              </p>
            </div>
          </div>
        )}

        <button onClick={nextSlide} className="nav-btn">&#8594;</button>
      </div>
    </section>
  );
};

export default Testimonial;
